import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import {
  YoutubeOutlined,
  TwitterOutlined,
  InstagramOutlined,
  FacebookOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";
import Container from "../../common/Container";
import {
  FooterSection,
  FooterGrid,
  FooterBrand,
  BrandName,
  BrandDescription,
  FooterColumn,
  ColumnTitle,
  FooterLink,
  Para,
  Extra,
  Copyright,
  FooterContainer,
  SocialLink,
} from "./styles";

const socialLinks = [
  {
    href: "https://www.youtube.com/@DataTendsGenTechnology",
    label: "YouTube",
    icon: YoutubeOutlined,
  },
  {
    href: "https://x.com/DataTenTech",
    label: "Twitter",
    icon: TwitterOutlined,
  },
  {
    href: "https://www.instagram.com/datatendsgentechnology/",
    label: "Instagram",
    icon: InstagramOutlined,
  },
  {
    href: "https://www.facebook.com/DataTendsGenTechnology/",
    label: "Facebook",
    icon: FacebookOutlined,
  },
  {
    href: "https://www.linkedin.com/company/datatentechnology/",
    label: "LinkedIn",
    icon: LinkedinOutlined,
  },
];

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
          <FooterGrid>
            <FooterBrand>
              <BrandName>
                DataTends
                <span>Gen Technology</span>
              </BrandName>
              <BrandDescription>
                Dashboards, automated reporting, and data analytics for hospitals and clinics -
                plus custom HMS, OPD, and billing software when your facility needs it.
              </BrandDescription>
              <FooterContainer>
                {socialLinks.map(({ href, label, icon: Icon }) => (
                  <SocialLink
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                  >
                    <Icon />
                  </SocialLink>
                ))}
              </FooterContainer>
            </FooterBrand>

            <FooterColumn>
              <ColumnTitle>Services</ColumnTitle>
              <FooterLink to="/services/data-analysis-reporting-automation">Data Analysis & Reporting</FooterLink>
              <FooterLink to="/services/healthcare-software-development">Software Development</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Solutions</ColumnTitle>
              <FooterLink to="/solutions/hospital-management-system">Hospital Management</FooterLink>
              <FooterLink to="/solutions/clinic-opd-software">Clinic & OPD</FooterLink>
              <FooterLink to="/solutions/ipd-opd-billing">IPD & OPD Billing</FooterLink>
              <FooterLink to="/solutions">View All Solutions</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>Company</ColumnTitle>
              <FooterLink to="/">{t("Home")}</FooterLink>
              <FooterLink to="/services">{t("Services")}</FooterLink>
              <FooterLink to="/contact">{t("Contact")}</FooterLink>
              <FooterLink to="/book">Book a Consultation</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <ColumnTitle>{t("Contact")}</ColumnTitle>
              <Para>Office No. 02, Nr. Vodafone Office, Begatekri, Kacheri Road, Dholka, Gujarat, India</Para>
              <Para style={{ marginTop: "1rem" }}>+91 9662617109</Para>
              <Para>info@datatentechnology.com</Para>
            </FooterColumn>
          </FooterGrid>
          {/* <ComplianceNote>
            Custom healthcare software for hospital owners, clinic operators, labs, and research centers.
            We also work with healthcare consultants and partners who procure software on behalf of facilities.
          </ComplianceNote> */}
        </Container>
      </FooterSection>
      <Extra>
        <Container>
          <Row justify="space-between" align="middle">
            <Col>
              <Copyright>
                © {new Date().getFullYear()} DATATENDS GEN TECHNOLOGY PRIVATE LIMITED. All rights reserved.
              </Copyright>
            </Col>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
